import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapLocationIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.9 4.4L13.9 21.96L10.66 14.4L3.02 11.34L20.9 4.4ZM11.98 13.04L13.88 17.6L17.92 7.26L7.4 11.36L11.98 13.04Z" />
    </SvgIcon>
  );
});
